import { useEffect, useRef } from "react";
import { WSQueryClient } from "../../../query/helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { sendMessageToParent } from "../utils/postMessage";

const isUnauthorized = (error: unknown) =>
  (error as WSServiceError | undefined)?.response?.status === 401;

export const useNotifyParentOnSessionExpired = () => {
  const isNotified = useRef(false);

  useEffect(() => {
    const notify = (error: unknown) => {
      if (isNotified.current || !isUnauthorized(error)) {
        return;
      }

      isNotified.current = true;
      sendMessageToParent("error", {
        code: "session_expired",
        message: "Your session has expired"
      });
    };

    const unsubscribeQueries = WSQueryClient.getQueryCache().subscribe(
      event => {
        if (event.type === "updated" && event.action.type === "error") {
          notify(event.action.error);
        }
      }
    );
    const unsubscribeMutations = WSQueryClient.getMutationCache().subscribe(
      event => {
        if (event.type === "updated" && event.action.type === "error") {
          notify(event.action.error);
        }
      }
    );

    return () => {
      unsubscribeQueries();
      unsubscribeMutations();
    };
  }, []);
};
